import React, { useState } from 'react';
import API_CONFIG from '../../config/api';

const DirectAPITest = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testDirectAPI = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    
    try {
      //console.log('Testing direct API call...');
      
      // Test 1: Direct fetch call
      const response = await fetch(`${API_CONFIG.API_BASE}/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      //console.log('Direct fetch response:', response);
      //console.log('Response status:', response.status);
      //console.log('Response headers:', response.headers);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      //console.log('Direct fetch data:', data);
      setResult({ method: 'Direct Fetch', data });
      
    } catch (err) {
      console.error('Direct fetch error:', err);
      setError(`Direct fetch error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testAxiosAPI = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    
    try {
      //console.log('Testing axios API call...');
      
      // Import axios dynamically
      const axios = (await import('axios')).default;
      
      const response = await axios.get(`${API_CONFIG.API_BASE}/users`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      //console.log('Axios response:', response);
      //console.log('Axios data:', response.data);
      setResult({ method: 'Axios', data: response.data });
      
    } catch (err) {
      console.error('Axios error:', err);
      setError(`Axios error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Direct API Test</h2>
      
      <div style={{ margin: '20px 0' }}>
        <button 
          onClick={testDirectAPI} 
          disabled={loading}
          style={{ marginRight: '10px', padding: '10px 20px' }}
        >
          {loading ? 'Testing...' : 'Test Direct Fetch'}
        </button>
        
        <button 
          onClick={testAxiosAPI} 
          disabled={loading}
          style={{ padding: '10px 20px' }}
        >
          {loading ? 'Testing...' : 'Test Axios'}
        </button>
      </div>
      
      {error && (
        <div style={{ color: 'red', margin: '10px 0', padding: '10px', backgroundColor: '#ffe6e6' }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {result && (
        <div style={{ margin: '20px 0' }}>
          <h3>Result ({result.method})</h3>
          <pre style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '15px', 
            borderRadius: '5px',
            overflow: 'auto',
            maxHeight: '400px'
          }}>
            {JSON.stringify(result.data, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default DirectAPITest;
